import { commonMessages as enMessages } from "./i18n/features/en/common-messages";
import { platformAdminCommon as enAdminCommon } from "./i18n/features/en/platform-admin-common";
import { commonMessages as jaMessages } from "./i18n/features/ja/common-messages";
import { platformAdminCommon as jaAdminCommon } from "./i18n/features/ja/platform-admin-common";
import { commonMessages as zhMessages } from "./i18n/features/zh/common-messages";
import { platformAdminCommon as zhAdminCommon } from "./i18n/features/zh/platform-admin-common";
import {
  DEFAULT_LOCALE,
  getLocale as sharedGetLocale,
  normalizeLocale,
  setLocale as sharedSetLocale,
  subscribeLocaleChange as sharedSubscribeLocaleChange,
} from "./i18n/locale-state";
import { createI18nRuntime } from "./i18n/runtime";

export type { AppLocale } from "./i18n/locale-state";
export { APP_LOCALE_LABELS, APP_LOCALES, DEFAULT_LOCALE, normalizeLocale } from "./i18n/locale-state";

const localeCatalogs = {
  "zh-CN": { common: { messages: zhMessages }, platform: { admin: { common: zhAdminCommon } } },
  en: { common: { messages: enMessages }, platform: { admin: { common: enAdminCommon } } },
  ja: { common: { messages: jaMessages }, platform: { admin: { common: jaAdminCommon } } },
} as const;

export const zhCN = localeCatalogs["zh-CN"];
export type Messages = typeof zhCN;

export const {
  messageCatalogs,
  setLocale,
  getLocale,
  subscribeLocaleChange,
  createMessageProxy,
  hasMessage,
  t,
  formatMessage,
  formatEnumPath,
  formatEnumLabel,
  formatBooleanLabel,
  formatLocalizedList,
  formatActionObjectLabel,
  formatActionObjectMessage,
  formatActionObjectIntlLabel,
} = createI18nRuntime({
  defaultLocale: DEFAULT_LOCALE,
  localeCatalogs,
  normalizeLocale,
  localeState: {
    getLocale: sharedGetLocale,
    setLocale: sharedSetLocale,
    subscribeLocaleChange: sharedSubscribeLocaleChange,
  },
});

export type {
  DeepPartialMessageTree,
  FormatMessageLike,
  MessageDescriptor,
  MessageParams,
  MessageTree,
} from "./i18n/runtime";
